import {create} from "zustand";

interface AssetSelectorState {
    selectedAssets: string[], // ids
    toggleSelectItem: (item: string) => void,
    clearSelection:()=>void,
    setItems:(items: string[])=>void
}
export const useAssetSelector = create<AssetSelectorState>((set)=> {
    return {
        selectedAssets: [],
        clearSelection:()=>{
            set({selectedAssets: []})
        },
        setItems:(items)=>{
            set({selectedAssets: items})
        },
        toggleSelectItem: (item) => {
            set((state) => {
                if (state.selectedAssets.includes(item)) {
                    return {
                        selectedAssets: state.selectedAssets.filter((i) => i !== item)
                    }
                } else {
                    return {
                        selectedAssets: [...state.selectedAssets, item]
                    }
                }
            })
        }
    }
})
